import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "32",
  height: "32",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#DFE8F9",
      d: "m24.23 24.7-1.24 3.87c-.27.53-.97.57-1.31.08l-3.98-7.01-1.28.03-3.96 6.98a.756.756 0 0 1-1.31-.06L9.9 24.71l-3.95.83a.743.743 0 0 1-.78-1.06l4.35-7.51s-.24-.6-.28-.71C6.75 9.44 13.72 2.97 20.39 5.91c4.2 1.85 6.06 6.8 4.17 10.97l4.42 7.63c.21.54-.21 1.07-.78 1.02z"
    }, null, -1),
    _createElementVNode("path", {
      fill: "#2B63D9",
      d: "M7.69 15.206a.75.75 0 1 1 1.3.748l-3.753 6.517 3.119-.655.14-.016a.75.75 0 0 1 .729.522l.957 3.002 3.355-5.942a.75.75 0 1 1 1.306.737l-4.2 7.44a.751.751 0 0 1-1.367-.141L8 23.423l-4.096.861a.751.751 0 0 1-.805-1.108zM22.206 14.93a.75.75 0 0 1 1.024.276l4.59 7.97a.75.75 0 0 1-.804 1.108l-4.088-.861-1.283 3.996a.751.751 0 0 1-1.369.14l-4.19-7.44a.75.75 0 0 1 1.308-.737l3.346 5.943.966-3.005a.75.75 0 0 1 .87-.504l3.107.655-3.752-6.517a.75.75 0 0 1 .275-1.024"
    }, null, -1),
    _createElementVNode("path", {
      fill: "#2B63D9",
      d: "M22.53 11.61c0-3.933-3.183-7.12-7.11-7.12-3.925 0-7.11 3.187-7.11 7.12s3.185 7.12 7.11 7.12 7.11-3.187 7.11-7.12m1.5 0c0 4.76-3.853 8.62-8.61 8.62-4.755 0-8.61-3.86-8.61-8.62s3.855-8.62 8.61-8.62c4.757 0 8.61 3.86 8.61 8.62"
    }, null, -1),
    _createElementVNode("path", {
      fill: "#2B63D9",
      d: "M14.93 7.33c.21-.37.66-.5 1.02-.28.11.07.2.16.27.28l.9 1.62c.11.19.28.32.49.37l1.76.4c.4.09.66.51.57.93a.9.9 0 0 1-.17.35l-1.2 1.4c-.14.16-.21.38-.19.6l.18 1.87c.04.43-.26.81-.67.85-.13.01-.26 0-.38-.06l-1.64-.76a.7.7 0 0 0-.6 0l-1.64.76c-.38.17-.82 0-.98-.4a.9.9 0 0 1-.06-.39l.18-1.87a.82.82 0 0 0-.19-.6l-1.2-1.4a.805.805 0 0 1 .06-1.1c.1-.09.21-.15.34-.18l1.76-.4c.2-.05.38-.18.49-.37z"
    }, null, -1)
  ]))]))
}
export default { render: render }